import { useQuery } from "@tanstack/react-query"
import { getStaticPageData } from "../../services/productService";
import { useParams } from "react-router-dom";

export default function StaticPage() {
    const params = useParams();
    const { data } = useQuery({
        queryKey: ["static_pages", params?.slug],
        queryFn: getStaticPageData,
    });
// console.log(data);
    const filterData = data?.filter((item) => item.slug === params?.slug)[0]

    return (
        <>
            <section className="section-header-title">
                <div className="max-w-6xl mx-auto px-4">
                    <h1>{filterData?.title || ""}</h1>
                </div>
            </section>
            <img
                src="/Image/border-bottom-title.png"
                className="w-full header-title-image"
                alt=""
            />
            <div className="index-section lg:px-24 md:px-24">
            <div
                style={{ fontFamily: "Tenor Sans" }}
                className="p-5"
                dangerouslySetInnerHTML={{
                    __html: filterData?.description,
                }}
            />
            </div>
        </>
    )
}
